export const OFFLINE_STATUS_TOOLBAR_LABELS = Object.freeze({
  OFFLINE_SNACKBAR_TITLE:
    "Time Clock is currently offline. Any punches will still be recorded and sent when it's back online.",
  OFFLINE_SNACKBAR_SUBTITLE:
    'Please inform your manager if this message keeps appearing.',
  ONLINE_SNACKBAR_TITLE: 'Time Clock is back online!',
  ONLINE_SNACKBAR_SUBTITLE: 'Punches created while offline will now be sent.',
  WIFI_ARIA_LABEL: 'Toggle offline status message',
  QUEUE_ARIA_LABEL: 'View offline punches',
  OFFLINE_PUNCH_SUBMIT_ERROR_TITLE:
    'An error has occurred while submitting offline punches.',
  OFFLINE_PUNCH_SUBMIT_ERROR_SUBTITLE:
    'If this persists please contact your manager.',
});

export const OFFLINE_STATUS_SNACKBAR_COLORS = Object.freeze({
  main: '#ED6C02',
  background: '#FFF4E6',
});

export const ONLINE_STATUS_SNACKBAR_COLORS = Object.freeze({
  main: '#388C3E',
  background: '#EAF3EB',
});

export const OFFLINE_PUNCH_ERROR_BANNER_COLORS = Object.freeze({
  main: '#D32F2F',
  background: '#FDEDED',
});

export const STATUS_SNACKBAR_AUTO_HIDE_MS = 3000;

export const STABLE_ONLINE_DEBOUNCE_MS = 3000;
